import { Link } from "react-router-dom";
import contactHero from "../images/contact_hero.svg";
import blueskyLogo from "../images/logos/Bluesky.png";
import mastadonLogo from "../images/logos/Mastodon.png";
import ZohoContactForm from "../components/ZohoContactForm";

export const Contact = () => {
  return (
    <>
      <div className="pageHero">
        <div className="pageHeroText">
          <h1 className="pageHeroTitle">Get in Touch</h1>
          <p className="pageHeroSubtitle">
            Have a question or ready to start a project? Fill out the form below
            and a real person will get back to you.
          </p>
        </div>
        <div className="pageHeroImageWrap hide-on-mobile">
          <img src={contactHero} alt="Contact Us" className="pageHeroImg" />
        </div>
      </div>

      <div className="pageContent">

        <div className="serviceSection serviceSectionTinted">
          <h3 className="sectionTitle" style={{ textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>What to Expect</h3>
          <p style={{ maxWidth: "560px", margin: "4px auto 28px", textAlign: "center" }}>
            We keep things simple, personal, and pressure-free.
          </p>
          <div className="aiCardsRow">
            <div className="aiFeatureCard">
              <h6>Quick Response</h6>
              <p>
                You will always hear back from a real person who knows your
                situation and is ready to help.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Expert Guidance</h6>
              <p>
                Every conversation starts with listening. We take the time to
                understand your goals before recommending any path forward.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>No Obligation</h6>
              <p>
                An initial consultation is always free. We want you to feel
                confident in your decision — never pressured.
              </p>
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <h3 className="sectionTitle" style={{ textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>Send Us a Message</h3>
          <p style={{ maxWidth: "580px", margin: "4px auto 28px", textAlign: "center" }}>
            Whether you have a question about a specific service, want to scope out
            a project, or just need some tech advice — we would love to hear from
            you. Fill out the form and we will be in touch.
          </p>
          <ZohoContactForm />
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <h3 className="sectionTitle" style={{ textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>Stay Connected</h3>
          <p style={{ maxWidth: "560px", margin: "4px auto 28px", textAlign: "center" }}>
            Follow us on social media for tips, updates, and a look at what we
            are working on.
          </p>
          <div className="socialLinks" style={{ maxWidth: "460px", margin: "0 auto" }}>
            <a
              href="https://bsky.app/profile/techguydom.com"
              target="_blank"
              rel="noreferrer"
              className="socialLinkItem"
            >
              <img src={blueskyLogo} alt="Bluesky" className="socialIcon" />
              <div>
                <div style={{ fontWeight: 700 }}>Bluesky</div>
                <div style={{ fontSize: "0.85rem", color: "#4a6278" }}>@TechGuyDom.com</div>
              </div>
            </a>
            <a
              href="https://twit.social/@TechGuyDom"
              target="_blank"
              rel="noreferrer"
              className="socialLinkItem"
            >
              <img src={mastadonLogo} alt="Mastodon" className="socialIcon" />
              <div>
                <div style={{ fontWeight: 700 }}>Mastodon</div>
                <div style={{ fontSize: "0.85rem", color: "#4a6278" }}>@TechGuyDom on twit.social</div>
              </div>
            </a>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="calloutBox">
            <h4>Want to Learn More First?</h4>
            <p style={{ color: "rgba(255,255,255,0.88)", marginBottom: "20px" }}>
              Take a look at what we offer before reaching out. It can help you
              figure out exactly what to ask — and we are always happy to fill
              in the gaps.
            </p>
            <Link to="/services" className="calloutCta">Explore Our Services</Link>
          </div>
        </div>

      </div>
    </>
  );
};
